export default __webpack_public_path__ + "static/media/heart.608bc9ba.svg";